import '../scss/style.scss'

import { accordion } from './modules/accordion'
import { tabs } from './modules/tabs'
import { overlayMenu } from './modules/overlay-menu'
import { pdfLinks } from './modules/pdf-links'
import { dropdown } from './modules/dropdown'
import { popup } from './modules/popup'
import { mainMenuExtraMarkup } from './modules/main-menu-extra-markup'
import { circles } from './modules/circles'
import { tabPanels } from './modules/tabpanels'

mainMenuExtraMarkup()

overlayMenu()

dropdown()

pdfLinks()

accordion()

tabs()

popup()

circles()

tabPanels()